import  { useState } from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postRules } from '../../../../MyApi/sb/rules'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddRule from '../../../../Components/sb/rules/rulesStore/AddRules'



const RulesStore = () => {
const [name ,setName]= useState("")
const [description ,setDescription]= useState("")
const [type ,setType] = useState("")
const [active, setActive] =useState(1)
const [durationType ,setDurationType]=useState("")
const [valueType ,setValueType]=useState("")
const [slug ,setSlug]=useState("")
const [defaultDuration ,setDefaultDuration]=useState("")
const [defaultValue ,setDefaultValue] =useState("")
const [default_process_type ,setDefaultProcessType]=useState("")
 const mutation = useMutation("postRules" , (postData)=>postRules(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setName("")
        setType("")
        setDurationType("")
        setSlug("")
        setDefaultDuration("")
        setDefaultValue("")
        setDescription("")
        setValueType("")
        setSlug("")
        setDefaultProcessType("")
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })


 const handlePostRequest =()=>{
    mutation.mutate({
        name,   
        description,
        type,
        active,
        duration_input_type:durationType,
        value_type: valueType,
        default_duration:defaultDuration,
        default_value:defaultValue,
        default_process_type,
        slug
    })
 }
 const isDisabled= ()=>{
  return  !(name  && type && active && durationType && slug && defaultValue && defaultDuration && valueType&&default_process_type )

 }
  return ( 

    <div>
        <PageHeader title="Add Rules"  showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddRule default_process_type={default_process_type}  defaultValue={defaultValue} setDefaultProcessType={setDefaultProcessType}  name={name} description={description} type={type} active={active} durationType={durationType} valueType={valueType}  defaultDuration={defaultDuration} setName={setName} setDescription={setDescription} setType={setType} setActive={setActive} setDurationType={setDurationType} setValueType={setValueType} setSlug={setSlug} setDefaultDuration={setDefaultDuration} setDefaultValue={setDefaultValue}/>
    </div>
  )
}

export default RulesStore